<script lang="ts">
	import type { presenterShortCollection, presenterShortUser } from '$lib/api/rpc';
	import UserPVcard from '$lib/components/UserPVCard/userPVcard.svelte';
	import { calculateRelativeTime } from '$lib/utils/calculateRelativeTime';
	import Popover from '$lib/components/Popover/Popover.svelte';
	import NameAndPill from '$lib/components/PostedBy/NameAndPill.svelte';
	import Avatar from '$lib/components/Avatar/Avatar.svelte';
	export let withPopover = false;
	export let user: presenterShortUser;
	export let user_role = '';
	export let time = '';
	export let collection: null | Collection | presenterShortCollection = null;
	import { getHubStores } from '$lib/stores/hubStores';
	import { page } from '$app/stores';
	import type { Collection } from '$lib/types/Collections';
	const { hub } = getHubStores();
</script>

<div class="wrapper">
	<Avatar url={user.avatar_url} name={user.name} />
	<div>
		<div class="px-posted-by">
			{#if withPopover}
				<Popover position="bottom-inline-end">
					<NameAndPill slot="target" name={user.name} {user_role} />
					<UserPVcard {user} slot="content" />
				</Popover>
			{:else}
				<NameAndPill name={user.name} {user_role} />
			{/if}
		</div>
		<div class="collectionAndDate">
			{#if collection}
				<a class="px-posted-in-collection" href={`/${$page.params.hubPrefix}/${collection.slug}`}>
					{collection.name}
				</a>
				<span>&nbsp;-&nbsp;</span>
			{/if}
			<h5 class="px-posted-in-date">{time ? calculateRelativeTime(time, $hub.locale) : ''}</h5>
			<slot name="collectionAndDate" />
		</div>
	</div>
</div>

<style>
	.wrapper {
		display: flex;
		align-items: center;
	}

	.px-posted-by {
		max-inline-size: 205px;
		padding-inline: var(--gutterSmall);
	}

	.collectionAndDate {
		display: flex;
		align-items: center;
		padding-inline: var(--gutterSmall);
		color: var(--hubDetailFontColor);
		font: var(--hubDetailFont);
		font-size: var(--fontSizeSmallest);
	}

	.px-posted-in-date,
	a {
		margin: 0;
		color: inherit;
		font-size: inherit;
	}
</style>
